// extracted by mini-css-extract-plugin
export var formContainer = "_kl-0";
export var message = "_kl-1";